import { Injectable } from '@angular/core';
import { Product } from './product';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  public products: Product[] = [
    new Product(
      "Color Match",
      "Mobile game where you can put your skills to the test! \nSimple yet challenging.",
      "My first proudly released product!",
      `https://play.google.com/store/apps/details?id=com.elumixor.ColorMatch`,
      `https://apps.apple.com/cz/app/color-match-spin-tap-react/id1525018660`,
      `rCxQmMovUAQ`)
  ]

  constructor() { }
}
